/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
export const SHARED_CONSTANTS = {
  ROOT_SHARED_MODULE: 'RootSharedModule',
  FOOTER_COMPONENT: 'FooterComponent',
  ERROR_404_ROUTE: 'error',
  ERROR_404_NAVIGATE: '/error',
  AEM_ERROR_NAVIGATE: '/content-error',
  SEARCH_RESULTS_LANDING_AEM_PATH: 'search',
  COVERAGE: 'Coverage',
  PLANS: 'Plans',
  COMPLETE: 'complete',
  ALMOST_THERE: 'Almost There',
  SHOP: 'Shop',
  PHONES: 'Phones',
  ACCESSORIES: 'Accessories',
  ONLY_DEVICE_ORDER: 'onlyDeviceOrder',
  TABLETS_AND_MORE: 'Tablets and More',
  DIRECT_TO_ACCOUNT_LINK: '/direct-to-account',
  REDEEM_GUEST: '/direct-to-account/redeem-guest',
  APPROVED: 'approved',
  BILLTYPE_PREPAID: 'prepaid',
  BILLTYPE_POSTPAID: 'postpaid',
  ANON_ACCOUNT: 'ANON',
  RETAIL_CHANNEL: 'retail',
  WEB_CHANNEL: 'web',
  SHARED: 'shared',
  ERROR: 'error',
  CART: '/cart',
  ACCOUNT_LANDING: '/account-landing',
  LINE_LANDING: '/line-landing',
  BYOD_URL: '/bring-your-own-device',
  BYOD_PHOENIX_URL: 'ext:/bring-your-own-phone',
  SUPPORT_LANDING: '/support-landing/account',
  DATE_FORMAT: 'MM/dd/yyyy',
  SEARCH_NAVIGATE: '/search',
  DEFAULT_COUNTRY: 'USA',
  HOME_PAGE: '/',
  ACTION_CODE_ADD: 'ADD',
  ACTION_CODE_RETAIN: 'RETAIN',
  ENGLISH_LANG: 'ENGLISH',
  SPANISH_LANG: 'ESPAÑOL',
  CLIENT_ID: 'Client Id',
  CODE: 'code',
  USER_ID: 'userId',
  STATE: 'state',
  MSISDN: 'msisdn',
  RETAIL_PDL_CHANNEL: 'In person',
  CARE_PDL_CHANNEL: 'Over the phone',
  GLOBAL: '/global',
  LIMIT: '49',
  LIMIT_SESSION_ID: '20',
  LIMIT_DATE: '5',
  AUTH: 'auth',
  PURCHASE_DATA_PASS: 'Purchase Data Pass',
  BYOD: 'Bring Your Own Device',
  SUPPORT: 'Support',
  MY_TMO: 'My T-Mobile',
  MY_ACCOUNT_HOME: 'My Account Home',
  MY_PROFILE: 'My Profile',
  LOGOUT: 'Logout',
  HOME: '/home',
  VIEW_DOCUMENT: '/view-document',
  SECURE_VIEW_DOCUMENT: '/secure-view-document',
  PUB_PEM_HEADER_START: '-----BEGIN PUBLIC KEY-----',
  PUB_PEM_HEADER_END: '-----END PUBLIC KEY-----',
  HARDSTOP: 'Hardstop',
  DIGITALDATA: 'digitalData',
  PAGE: 'page',
  PAGEINFO: 'pageInfo',
  URL: 'url',
  REFERRER: 'referrer',
  EN: 'en',
  ES: 'es',
  CANONICAL: 'canonical-url',
  DEVICEDETAILURL: '/productDetails/deviceDetails',
  PRODUCTSELECTOR: '/product-selector',
  PRODUCTDETAIL: 'product-details',
  DEFAULT_PLACEHOLDER: '{0}',
  DESC_PLACEHOLDER:
    'Shop the {0} with features, pricing and reviews. Pair it with one of our high-speed 5G prepaid phone plans at T-Mobile Prepaid.',
  SEARCH: '/search',
  FREE_FORM_TEXT: 'Search Results Freeform Text Entry',
  CART_COUNT_COOKIE_NAME: 'cartCountCookieName',
  PREPAID_BRAND_NAME: 'TMOPrepaid',
  CONNECT_BRAND_NAME: 'connect',
  DUMMY_CART_PROMO: 'DUMMY_CART_PROMO',
  STATE_KEY: 'state',
  PRIDA_ID_TOKEN_COOKIE_NAME: 'pridaIdTokenCookieName',
  PRIDA_ID_TOKEN_COOKIE_EXP_MINS: 'pridaIdTokenCookieExpMins',
  COOKIE_DELETE_EXP: 'Thu, 01 Jan 1970 00:00:00 UTC',
  RATE_PLANS: '/change-plans-services/rate-plans',
  RATE_SERVICES: '/change-plans-services/rate-services',
  EFFECTIVE_DATE: '/change-plans-services/set-effective-date',
  PORT_IN: '/change-msisdn/port-in'
};
